import React from 'react';
import './style.scss';

const ParallaxBackground = () => (
  <div className="parallax">
    <div id="stars1" />
    <div id="stars2" />
    <div id="stars3" />
  </div>
);

export default ParallaxBackground;
